var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-4"},[_c('h4',{staticClass:"mt-3 mb-4 pb-4 border-bottom"},[_vm._v("Geräte")]),(_vm.isLoading === false)?_c('div',{staticClass:"row justify-content-start"},_vm._l((_vm.devices),function(device,index){return _c('DeviceCardComponent',{key:`device-${index}`,attrs:{"device":device}})}),1):_c('SpinnerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }